import React, { Component } from  'react';
import * as d3 from 'd3';
import {
  Row, Card, Col,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faVideo, faAward, faPlay } from '@fortawesome/free-solid-svg-icons'
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import SafeLink from './SafeLink';

class ProjectGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    }
  }

  render() {

    return <Row>
      {
        this.state.data.map((project, i) => {
          return <Col sm={6} md={6} key={"project" + i} className="project-col">
            <Card style={{ width: "100%", height: project.height }} className="project-card">

              <Card.Body>
                <SafeLink url={project.link} className="text-body">
                  <Card.Title className="mb-0">
                    {project.title}
                  </Card.Title>
                  <small>{
                    project.authors.map((name, i) => {
                      let decoratedName = name + ", "
                      if (i === project.authors.length - 1) {
                        decoratedName = decoratedName.replace(", ", "")
                      }

                      if (name==="Younghoon Kim") {
                        return <strong key={`author-${decoratedName}-${i}`}>{decoratedName}</strong>
                      }
                      return <span key={`author-${decoratedName}-${i}`}>{decoratedName}</span>
                    })
                  }</small>
                  <Card.Img variant="top" src={project.thumbnail} />
                  <Card.Text className="mt-1">
                    {project.description}
                  </Card.Text>
                </SafeLink>
                <Card.Text className="mt-1">
                  {
                    project.award ?
                    <span className="award bg-warning"><FontAwesomeIcon icon={faAward}/> {project.award}</span> :
                      ""
                  }
                  {
                    project.paper ?
                      <SafeLink url={project.paper} className="project-link"><FontAwesomeIcon icon={faFile}/> Paper</SafeLink> :
                      ""
                  }
                  {
                    project.demo ?
                    <SafeLink url={project.demo} className="project-link"><FontAwesomeIcon icon={faPlay}/> Demo</SafeLink> :
                    ""
                  }
                  {
                    project.github ?
                    <SafeLink url={project.github} className="project-link"><FontAwesomeIcon icon={faGithub}/> Code</SafeLink> :
                    ""
                  }
                  {
                    project.talk ?
                    <SafeLink url={project.talk} className="project-link"><FontAwesomeIcon icon={faVideo}/> Talk</SafeLink> :
                    ""
                  }
                </Card.Text>
              </Card.Body>

            </Card>
          </Col>
        })
      }
    </Row>
  }

  async componentDidMount() {
    const data = await d3.json("data/projects.json")
    this.setState({data});
  }

}

export default ProjectGallery;

